<div class="btn-group m-0" [class.btn-sm]="sm">
    <div class="checkbox btn" [class.btn-info-outline]="!value" [class.b-btn-slim]="slim" [class.disabled]="(disabled || readonly)" [class.btn-primary]="value" (click)="runUpdate(true)">
        Yes
    </div>
    <div class="checkbox btn btn-info-outline" [class.btn-info-outline]="value" [class.b-btn-slim]="slim" [class.disabled]="(disabled || readonly)" [class.btn-primary]="!value" (click)="runUpdate(false)">
        No
    </div>
</div>
